import { ApiEndpoints } from "@shared/api/api-endpoints";
import {
  onboardingApiClient,
} from "@shared/api/clients/apiClientFactory";
import { SubscriptionPlan } from "./types";

export const subscriptionApi = {
  // Get all utilities
  getSubscriptionPlan: async (): Promise<any> => {
    const url = ApiEndpoints.createUrlWithQueryParameters(
      "auth",
      "subscription-plan",
    );
    const response = await onboardingApiClient.get(url);
    return response.data ?? [];
  },

   getAddOnsList: async (tenantId: string) => {
    const url = ApiEndpoints.createUrlWithQueryParameters(
      "auth",
      "subscriptions/addons",
      (query) => {
        query.push('tenant_id', tenantId)
      }
    );
    const response = await onboardingApiClient.get(url);
    return response.data.result ?? [];
  },

  getCurrentSubscription: async (tenantId: string) => {
    const url = ApiEndpoints.createUrlWithQueryParameters(
      "auth",
      "subscriptions/current",
      (query) => {
        query.push('tenant_id', tenantId)
      }
    );
    const response = await onboardingApiClient.get(url);
    return response.data.result ?? [];
  },

  getSupportRequests: async (tenantId: string) => {
    const url = ApiEndpoints.createUrlWithQueryParameters(
      "auth",
      "support/requests",
      (query) => {
        query.push('tenant_id', tenantId)
      }
    );
    const response = await onboardingApiClient.get(url);
    return response.data.result ?? [];
  },

  postAddons: async (payload: any) => {
  const url = ApiEndpoints.createUrl("auth", "subscriptions/addons/add");
  const response = await onboardingApiClient.post(url, payload);
  return response.data;
},
 postAddSubscription: async (payload: any) => {
  const url = ApiEndpoints.createUrl("auth", "support/contact-sales");
  const response = await onboardingApiClient.post(url, payload);
  return response.data;
},
}
